import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { PrefixSimplifiedType } from '../../interfaces/Prefix'
import { getValidators } from '../../../httpClient/Requests/Api/TEMPO/system'
import { LookupState } from '../../interfaces/LookupState'
import { Lookup } from '../../../httpClient/interfaces/Lookup'

export const initialState: LookupState = {
    data: [],
    loading: false,
    error: null,
}

export const fetchValidators = (prefix: PrefixSimplifiedType) =>
    createAsyncThunk(`${prefix}/validators/fetchValidators`, async () => {
        let validators: Lookup[] = []
        if (prefix.includes('TEMPO')) {
            const response = await getValidators()
            validators = response.data
        }
        return validators
    })

const validatorsSlice = (prefix: PrefixSimplifiedType) =>
    createSlice({
        name: `${prefix}/validators`,
        initialState,
        reducers: {},
        extraReducers: (builder) => {
            builder.addCase(fetchValidators(prefix).pending, (state) => ({ ...state, loading: true, error: null }))
            builder.addCase(fetchValidators(prefix).fulfilled, (state, action) => ({
                ...state,
                data: action.payload,
                loading: false,
                error: null,
            }))
            builder.addCase(fetchValidators(prefix).rejected, (state, action) => ({
                ...state,
                loading: false,
                error: action.error,
            }))
        },
    })

const validators = (prefix: PrefixSimplifiedType) => validatorsSlice(prefix).reducer

export default validators
